"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "checkCoastalA", {
    enumerable: true,
    get: function() {
        return checkCoastalA;
    }
});
const _constants = require("../constants");
const checkCoastalA = (account)=>account.coastalADetermination !== _constants.COASTAL_A_DETERMINATION.DISABLED;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3V0aWxzL2NvYXN0YWxBLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IENPQVNUQUxfQV9ERVRFUk1JTkFUSU9OIH0gZnJvbSBcIi4uL2NvbnN0YW50c1wiO1xuXG5leHBvcnQgY29uc3QgY2hlY2tDb2FzdGFsQSA9IChhY2NvdW50OiB7IGNvYXN0YWxBRGV0ZXJtaW5hdGlvbjogc3RyaW5nIH0pID0+XG4gIGFjY291bnQuY29hc3RhbEFEZXRlcm1pbmF0aW9uICE9PSBDT0FTVEFMX0FfREVURVJNSU5BVElPTi5ESVNBQkxFRDtcbiJdLCJuYW1lcyI6WyJjaGVja0NvYXN0YWxBIiwiYWNjb3VudCIsImNvYXN0YWxBRGV0ZXJtaW5hdGlvbiIsIkNPQVNUQUxfQV9ERVRFUk1JTkFUSU9OIiwiRElTQUJMRUQiXSwibWFwcGluZ3MiOiI7Ozs7K0JBRWFBOzs7ZUFBQUE7OzsyQkFGMkI7QUFFakMsTUFBTUEsZ0JBQWdCLENBQUNDLFVBQzVCQSxRQUFRQyxxQkFBcUIsS0FBS0Msa0NBQXVCLENBQUNDLFFBQVEifQ==